import React from 'react';
import techFoundationImg from '../../../assets/images/servicepage/tech_foundation.svg';
import Constants from '../../../app/utils/constants';

const TechFoundation = () => {
  const { techFoundation } = Constants.servicePage;

  return (
    <section className="relative flex w-full flex-col items-center justify-center overflow-hidden pb-16 lg:pb-18 xl:pb-20 2xl:pb-24 min-[2560px]:pb-32">
      
      {/* Title */}
      <div className="relative z-10 mt-10 mb-12 text-center lg:mb-14 xl:mb-16">
        <h2 className="font-rajdhani text-2xl font-semibold text-white tracking-wide md:text-5xl lg:text-[48px] xl:text-[56px] 2xl:text-[64px] min-[2560px]:text-[86px]">
          {techFoundation.title}
        </h2>
      </div>

      <div className="relative flex w-full max-w-[1450px] items-center justify-center px-4 md:px-8 lg:px-10 xl:max-w-[1600px] 2xl:max-w-[1900px] min-[2560px]:max-w-[2300px] min-[2560px]:px-16">
        <img 
          src={techFoundationImg} 
          alt="Technology Foundation Map" 
          className="w-full h-auto object-contain transition-transform duration-500 "
        />
      </div>
    </section>
  );
};

export default TechFoundation;
